import React, { useEffect, useReducer } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { handleChange } from 'Brands/services/services'
import { passwordReg, phoneNumReg, textReg } from 'Brands/utils/Regex'
import FieldError from 'components/FieldError'
import CountrySelector from 'components/CountrySelector'
import arrow from 'assets/images/campaign/ArrowDown.png'
import { middleEastCountries } from 'Brands/containers/Authentication/CompanyForm/Constants'
import RegionSelector from 'components/RegionSelector'
import LoaderComponent from 'components/Loader'

const SaveButton = styled(Button)`
  background: #5cc847;
  color: #fff;
  border: none;
  :hover {
    background: #5cc847;
    color: #000;
    border: none;
  }
  :disabled {
    background-color: #9e9e9e;
    border-color: #9e9e9e;
  }
`

export default function ProfileForm(props) {
  const { edit, profileInput, userData, handleSubmit, setInput, load } = props

  const [userInputError, setUserInputError] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      first_name: false,
      last_name: false,
      phone: false,
      password: false,
      conf: false,
    },
  )
  useEffect(() => {
    if (profileInput.conf !== profileInput.password) {
      setUserInputError({ conf: true })
    } else {
      setUserInputError({ conf: false })
    }
  }, [profileInput.conf, profileInput.password])
  const validateForm = () => {
    return (
      profileInput.first_name?.trim().length > 0 &&
      !userInputError.first_name &&
      profileInput.last_name?.trim().length > 0 &&
      !userInputError.last_name &&
      profileInput.phone?.trim().length > 0 &&
      !userInputError.phone &&
      (profileInput.password?.trim().length > 0
        ? !userInputError.password
        : true) &&
      (profileInput.conf?.trim().length > 0 ? !userInputError.conf : true)
    )
  }
  return (
    <Row>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            id="email"
            value={profileInput.email}
            disabled
          />
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            id="phone"
            value={profileInput.phone}
            disabled={!edit}
            onChange={e =>
              handleChange(e, phoneNumReg, setInput, setUserInputError)
            }
            isInvalid={profileInput.phone?.length && userInputError.phone}
          />
          {profileInput.phone && userInputError.phone && (
            <FieldError message="Must be a valid phone number" />
          )}
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            id="first_name"
            value={profileInput.first_name}
            disabled={!edit}
            onChange={e =>
              handleChange(e, textReg, setInput, setUserInputError)
            }
            isInvalid={
              profileInput.first_name.length && userInputError.first_name
            }
          />
          {profileInput.first_name && userInputError.first_name && (
            <FieldError message="This field must be only characters" />
          )}
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            id="last_name"
            value={profileInput.last_name}
            disabled={!edit}
            onChange={e =>
              handleChange(e, textReg, setInput, setUserInputError)
            }
            isInvalid={
              profileInput.last_name.length && userInputError.last_name
            }
          />
          {profileInput.last_name && userInputError.last_name && (
            <FieldError message="This field must be only characters" />
          )}
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Country</Form.Label>
          <CountrySelector
            id="country"
            boxsizing="border-box"
            fontFamily="Montserrat"
            fontSize="0.9em"
            color="#495057"
            fontWeight="300"
            height="2.7em"
            border="1px solid #ced4da"
            borderradius=".25rem"
            backgroundcolor={edit ? '#fefefe' : '#e9ecef'}
            boxshadow="inset 0 2px 3px 0 rgba(0,0,0,0.08)"
            backgroundimage={`url(${arrow})`}
            backgroundsize="1em 1em"
            left="0.9em"
            disabled={!edit}
            country={profileInput.country}
            onChange={e =>
              setInput({
                country: e,
              })
            }
            countries={middleEastCountries}
          />
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>City</Form.Label>
          <RegionSelector
            id="city"
            boxsizing="border-box"
            fontFamily="Montserrat"
            fontSize="0.9em"
            color="#495057"
            fontWeight="300"
            height="2.7em"
            left="0.9em"
            border="1px solid #ced4da"
            borderradius="0.25rem"
            backgroundcolor={edit ? '#fefefe' : '#e9ecef'}
            boxshadow="inset 0 2px 3px 0 rgba(0,0,0,0.08)"
            backgroundimage={`url(${arrow})`}
            backgroundsize="1em 1em"
            disabled={!edit}
            country={profileInput.country}
            region={profileInput.city}
            onChange={e =>
              setInput({
                city: e,
              })
            }
          />
          {/*<Form.Control*/}
          {/*  type="text"*/}
          {/*  id="city"*/}
          {/*  value={profileInput.city}*/}
          {/*  disabled={!edit}*/}
          {/*  onChange={handleChange}*/}
          {/*/>*/}
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>New Password</Form.Label>
          <Form.Control
            type="password"
            id="password"
            value={profileInput.password}
            disabled={!edit}
            onChange={e =>
              handleChange(e, passwordReg, setInput, setUserInputError)
            }
            isInvalid={profileInput.password.length && userInputError.password}
          />
          {profileInput.password && userInputError.password && (
            <FieldError message="Password must be 8+ characters and include at least an alphabetic character , a special character , a number " />
          )}
        </Form.Group>
      </Col>
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            id="conf"
            disabled={!edit}
            value={profileInput.conf}
            onChange={e => setInput({ conf: e.target.value })}
          />
          {profileInput.conf && userInputError.conf && (
            <FieldError message="Password and Conf password not match" />
          )}
        </Form.Group>
      </Col>
      {/*<Col md={6} className="mt-4">*/}
      {/*  <Form.Group>*/}
      {/*    <Form.Label>Bank Account Number</Form.Label>*/}
      {/*    <Form.Control*/}
      {/*      type="text"*/}
      {/*      id="bank_account_number"*/}
      {/*      required*/}
      {/*      value={profileInput.bank_account_number}*/}
      {/*      disabled={!edit}*/}
      {/*      onChange={handleChange}*/}
      {/*    />*/}
      {/*  </Form.Group>*/}
      {/*</Col>*/}
      {/*<Col md={6} className="mt-4">*/}
      {/*  <Form.Group>*/}
      {/*    <Form.Label>*/}
      {/*      National ID / Iqama Number <FontAwesomeIcon icon={faInfoCircle} />*/}
      {/*    </Form.Label>*/}
      {/*    <Form.Control*/}
      {/*      type="text"*/}
      {/*      id="national_id"*/}
      {/*      required*/}
      {/*      placeholder="xxxxxxxxxxxxxx"*/}
      {/*      value={profileInput.national_id}*/}
      {/*      disabled={!edit}*/}
      {/*      onChange={handleChange}*/}
      {/*    />*/}
      {/*    <Form.Text id="emailHelp" className="text-muted">*/}
      {/*      Your information will be used to transfer cash to your bank account.*/}
      {/*    </Form.Text>*/}
      {/*  </Form.Group>*/}
      {/*</Col>*/}
      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>Gender</Form.Label>
          <Form.Control
            as="select"
            id="gender"
            value={profileInput.gender}
            disabled={!edit}
            onChange={e => setInput({ gender: e.target.value })}
          >
            <option>Male</option>
            <option>Female</option>
          </Form.Control>
        </Form.Group>
      </Col>

      <Col md={6} className="mt-4">
        <Form.Group>
          <Form.Label>
            Promocode <FontAwesomeIcon icon={faInfoCircle} />
          </Form.Label>
          <Form.Control
            type="text"
            id="promo_code"
            value={userData.referral}
            disabled
          />
          <Form.Text id="emailHelp" className="text-muted">
            Promo code will be used by Jazeel to build your custom link which
            you can share on social media with friends and fans.
          </Form.Text>
        </Form.Group>
        {edit ? (
          <Col md={12} className="text-center">
            <SaveButton
              size="lg"
              className="mt-4 px-5 py-2"
              onClick={handleSubmit}
              disabled={!validateForm() || load}
            >
              Save Changes
            </SaveButton>
            <LoaderComponent
              visible={load}
              type="ThreeDots"
              height={25}
              width={25}
              color="white"
              top="-3vh"
              bottom="0"
            />
          </Col>
        ) : null}
      </Col>
    </Row>
  )
}

ProfileForm.propTypes = {
  edit: PropTypes.bool,
  profileInput: PropTypes.object,
  userData: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  setInput: PropTypes.func,
  load: PropTypes.any,
}
